
import './InfosAcces.css'


const InfosAcces = ({ item }) => {

    const renderInfosAcces = () => {

        if (item.InfosAcces != null) {
            return (
                <>
                    <br />
                    <div className="title">Accès</div>
                    <div className="paddingH-30 txt-size-095">
                        {item.InfosAcces}
                    </div>
                </>
            )
        }

        return null
    }

    return (
        <div className="infos-acces">
            <div className="title">Adresse</div>
            <div className="paddingH-30 txt-size-095">
                {item.Ligne1 != null ? <div>{item.Ligne1}</div> : null}
                {item.Ligne2 != null ? <div>{item.Ligne2}</div> : null}
                <div>
                    {item.CodePostal == null ? '' : item.CodePostal + ' '}
                    {item.Ville == null ? '' : item.Ville}
                    {item.Wilaya == null ? '' : ' - ' + item.Wilaya}
                </div>
            </div>
            {renderInfosAcces()}
        </div>
    )
}

export default InfosAcces